export const getProductDetailsHref = (productUuid: string, productSlug?: string | null, storeUuid?: string) => {
    const path = `/product/${productUuid}/${productSlug || 'product'}`;

    if (!storeUuid) {
        return path;
    }

    return `${path}?store=${encodeURIComponent(storeUuid)}`;
};
